import { t } from "i18next";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";
import { ZUser } from "src/types";

import { columnDisplayId, sysColumnsHistory } from "../sysData/sysColumns";

export const makeUsersColumns = (): RtColumn<ZUser>[] => [
  columnDisplayId,
  {
    key: "lastName",
    title: t("Last name"),
    width: 120,
    render: (row: ZUser) => row.lastName,
  },
  {
    key: "firstName",
    title: t("First name"),
    width: 120,
    render: (row: ZUser) => row.firstName,
  },
  {
    key: "middleName",
    title: t("Middle name"),
    width: 120,
    render: (row: ZUser) => row.middleName,
  },
  {
    key: "email",
    title: t("Email"),
    width: 200,
    render: (row: ZUser) => row.email,
  },
  {
    key: "login",
    title: t("Login"),
    width: 150,
    render: (row: ZUser) => row.login,
  },
  {
    key: "metadataEditor",
    title: t("Metadata editor"),
    width: 150,
    render: (row: ZUser) => (row.metadataEditor ? t("Yes") : t("No")),
  },
  {
    key: "roles",
    title: t("Roles"),
    width: 150,
    render: (row: ZUser) => row.roles.map((role) => role.name).join(", "),
  },
  {
    key: "active",
    title: t("Status"),
    width: 100,
    render: (row: ZUser) => (row.active ? t("Active") : t("Deactivated")),
  },
  ...sysColumnsHistory,
];
